import { createFileRoute } from '@tanstack/react-router';
import { EyeOff } from 'lucide-react';
import { ComingSoonPage } from '@/components/sysadmin/coming-soon';

export const Route = createFileRoute('/sysadmin/governance/pii')({
  component: () => (
    <ComingSoonPage
      icon={EyeOff}
      title="PII Packs"
      specRef="§3.5 [v2]"
      wave="Phase 6"
      description="Regex + NER PII detection packs (multilingual). Redaction policies for queries, responses, audit logs, OCR-extracted text. PII never leaks to LLM unless via authorized MCP tool. PR-A ships v1 with Guardrails / Compliance / Classification only; PII is scaffolded for Phase 6."
      bullets={[
        'Regex packs — phone, email, SSN, credit card, regional IDs',
        'NER packs — name, location, organization, date',
        'Multilingual — at minimum US-EN, ES, DE, FR, JP',
        'Redaction policy editor — replace / hash / mask / drop',
        'Coverage check — verify packs are loaded into the inference path',
        'HIPAA PHI overlay — 18 Safe Harbor identifiers (today partial in PHI detector)',
      ]}
    />
  ),
});
